import React from 'react';

import '../styles/Setbox.scss' 

const SetboxTemplate = ({className, title, item01, item02, price, url}) => {

    return (
        <section className={className} >
            <div className="setbox__inner">
                <div className="setbox__text">
                    <h3 className="setbox__title">{title}</h3>
                    <ul className="setbox__list">
                        <li className="setbox__item">{item01}</li>
                        <li className="setbox__item">{item02}</li>
                    </ul>
                    <p className="setbox__price">&yen;{price}</p>
                    <a href={url} className="available">ONLINE STORE</a>
                    {/* <a>COMING SOON</a> */}
                </div>
            </div>
        </section>
    )
}

export default SetboxTemplate